export const videoLanguages = [
  { id: 'english', label: 'English' },
  { id: 'hindi', label: 'Hindi' },
  { id: 'malayalam', label: 'Malayalam' },
  { id: 'tamil', label: 'Tamil' },
  { id: 'telugu', label: 'Telugu' }
];
